/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import BaseWidget from 'scripts/base-widget';
import template from './live-video-advert.stache';
import 'components/custom-merchandise/custom-merchandise';
import 'components/dfp-advert-unit/dfp-advert-unit';

const ViewModel = can.Map.extend({
    onAdDidNotRender() {
        this.attr('renderMerchandiseUnit', true);
    },
    define: {
        customMerchandise: {
            Type: can.Map,
            Value: null,
        },
        adUnitPath: {
            type: 'string',
        },
        adReloadInterval: {
            type: 'number',
        },
        adSizes: {
            Type: can.List,
            Value: can.List,
        },
        adLegacy: {
            type: 'boolean',
        },
        adLegacyType: {
            type: 'string',
        },
        renderMerchandiseUnit: {
            type: 'boolean',
            value: false,
        },
    },
});

export const LiveVideoAdvert = BaseWidget.extend({
    init: function() {
        this.viewModel = new ViewModel({
            customMerchandise: this.options.customMerchandise,
            adUnitPath: this.options.adUnitPath,
            adReloadInterval: this.options.adReloadInterval,
            adSizes: this.options.adSizes,
            adLegacy: this.options.adLegacy,
            adLegacyType: this.options.adLegacyType,
        });
        this.view = template;
        this._super();
    },
});
